// Copyright (C) 2021 TANNER AG

import React from "react";
import EMobilityContentItem from "./EMobilityContentItem";

const EMobilityContent = ({ eMobilityContents, number, withNavBar }) => {
    if (!eMobilityContents || !eMobilityContents.length) {
        return null;
    }

    return (
        <React.Fragment>
            {eMobilityContents.map((content, index) => (
                <EMobilityContentItem key={index} index={index} content={content} number={number} withNavBar={withNavBar}/>
            ))}
        </React.Fragment>
    );
};

export default EMobilityContent;



// WEBPACK FOOTER //
// ./src/emobility/EMobilityContent.js